import { useState } from "react";
import { hosts } from "@/mocks/hosts";

export default function HostStorySection() {
  const [activeHost, setActiveHost] = useState(0);
  const host = hosts[activeHost];

  return (
    <section id="host-story" className="py-12 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-14">
          <div className="inline-flex items-center gap-2 text-amber-600 text-xs font-semibold tracking-widest uppercase mb-3">
            <i className="ri-user-heart-line"></i>
            HOST STORY
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-stone-800 mb-3">
            왜 한국인 호스트인가요?
          </h2>
          <p className="text-stone-500 text-sm max-w-xl mx-auto leading-relaxed">
            단순한 숙소 대여가 아닙니다. 후쿠오카에 정착한 한국인 호스트들이
            직접 챙겨주는 진짜 현지 여행을 경험하세요.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-12 items-start">
          {/* Host Selector */}
          <div className="space-y-3">
            {hosts.map((h, idx) => (
              <button
                key={h.id}
                onClick={() => setActiveHost(idx)}
                className={`w-full text-left p-4 sm:p-5 rounded-2xl transition-all cursor-pointer border ${
                  activeHost === idx
                    ? "border-amber-400 bg-amber-50"
                    : "border-stone-100 bg-stone-50 hover:border-amber-200"
                }`}
              >
                <div className="flex items-center gap-3 sm:gap-4">
                  <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-full overflow-hidden shrink-0">
                    <img src={h.image} alt={h.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-0.5">
                      <span className="font-semibold text-stone-800 text-sm">{h.name}</span>
                      {activeHost === idx && (
                        <span className="text-xs bg-amber-500 text-white px-2 py-0.5 rounded-full whitespace-nowrap">선택됨</span>
                      )}
                    </div>
                    <p className="text-xs text-stone-500 truncate">{h.title}</p>
                  </div>
                  <div className="flex items-center gap-1 text-amber-500 shrink-0">
                    <i className="ri-star-fill text-xs"></i>
                    <span className="text-xs font-semibold text-stone-700">{h.rating}</span>
                  </div>
                </div>
              </button>
            ))}
          </div>

          {/* Host Detail */}
          <div className="bg-stone-50 rounded-3xl p-5 sm:p-8">
            <div className="flex items-center gap-4 sm:gap-5 mb-5 sm:mb-6">
              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl overflow-hidden shrink-0">
                <img src={host.image} alt={host.name} className="w-full h-full object-cover object-top" />
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-stone-800 mb-1">{host.name} 호스트</h3>
                <p className="text-sm text-stone-500 mb-2">{host.title}</p>
                <div className="flex flex-wrap items-center gap-2 sm:gap-3 text-xs text-stone-400">
                  <span><i className="ri-calendar-line mr-1"></i>{host.since}년 시작</span>
                  <span><i className="ri-map-pin-line mr-1"></i>거주 {host.yearsInFukuoka}년</span>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-2 mb-4 sm:mb-5">
              {host.languages.map((lang) => (
                <span key={lang} className="text-xs bg-white border border-stone-200 text-stone-600 px-3 py-1 rounded-full">
                  <i className="ri-translate-2 mr-1"></i>{lang}
                </span>
              ))}
            </div>

            <blockquote className="text-sm text-stone-600 leading-relaxed mb-5 sm:mb-6 border-l-4 border-amber-400 pl-4">
              "{host.bio}"
            </blockquote>

            <div>
              <p className="text-xs font-semibold text-stone-500 uppercase tracking-wider mb-3">도움 드릴 수 있어요</p>
              <div className="space-y-2">
                {host.helps.map((help) => (
                  <div key={help} className="flex items-center gap-3 text-sm text-stone-700">
                    <div className="w-5 h-5 flex items-center justify-center bg-amber-100 rounded-full shrink-0">
                      <i className="ri-check-line text-amber-600 text-xs"></i>
                    </div>
                    {help}
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-5 sm:mt-6 pt-4 sm:pt-5 border-t border-stone-200 flex flex-col sm:flex-row sm:items-center justify-between gap-2">
              <div className="text-xs text-stone-400">
                <i className="ri-chat-1-line mr-1"></i>카카오톡 실시간 상담 가능
              </div>
              <div className="flex items-center gap-1.5 text-amber-500">
                {[1,2,3,4,5].map((i) => (
                  <i key={i} className="ri-star-fill text-xs"></i>
                ))}
                <span className="text-xs font-semibold text-stone-700 ml-1">{host.rating}</span>
                <span className="text-xs text-stone-400">({host.reviews})</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
